import {
  Box,
  Button,
  Flex,
  Heading,
  IconButton,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
} from "@chakra-ui/react";
import TagModal from "../Tags/TagDrawer";
import React, { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { BiConversation, BiMessageSquareDetail } from "react-icons/bi";
import { HiOutlineCpuChip } from "react-icons/hi2";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineSettingsVoice } from "react-icons/md";
import { PiBookOpenTextLight } from "react-icons/pi";
import { TiChartBarOutline } from "react-icons/ti";
import { VscTools } from "react-icons/vsc";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { SettingContext } from "../Settings/Reducer/SettingProvider";
import AllowHumanHandover from "./AllowHumanHandover";
import AssistantType from "./AssistantType";
import BasicDetails from "./BasicDetails";
import ConnectTools from "./ConnectTools";
import ConversationFields from "./ConversationFields";
import DataSourcesField from "./DataSourcesField";
import FormFields from "./FormFields";
import LLMrelated from "./LLMrelated";
import Prompt from "./Prompt";
import VoicesField from "./VoicesField";
import WebhookAndIntentFields from "./WebhookAndIntentFields";
import { IoMdArrowRoundBack } from "react-icons/io";
import useTagSelect from "../Tags/useTagSelect";
import { GrDeploy } from "react-icons/gr";
import NewDeployemnt from "./NewDeployemnt";

const AddEditAssistant_new = () => {
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme, myDetails } = agency;
  const assistantFormMethod = useForm({
    defaultValues: {
      assistant_type: "simple",
      templatePhonePrompt: undefined,
      voice: true,
      hide_ds: false,
      has_human_agent: false,
      use_tools: false,
      voiceLanguages: [],
      llmModel: null,
      systemPrompt: "",
      attributes: {
        conversation: false,
        contact: false,
        first_sentence: "",
        interruption_time: 10,
      },
      conversation_flow_id: null,
    },
  });
  const { handleSubmit, watch, setValue, reset, getValues } =
    assistantFormMethod;

  const baseUrl = getHostDomain();
  const { assistantId } = useParams();
  const navigate = useNavigate();

  const [myownVoiceOptions, setMyownVoiceOptions] = useState([]);
  const [editData, setEditData] = useState(null);
  const [member, setMember] = useState(false);
  const { state } = useContext(SettingContext);

  const [promptType, setPromptType] = useState("");
  const [status, setStatus] = useState("idle");
  const [linkAssistantTools, setLinkAssistantTools] = useState([]);
  const loading = status === "loading";
  const resetForm = () =>
    reset({
      assistant_type: "simple",
      voice: true,
      llmModel: null,
      systemPrompt: "",
      description: "",
      name: "",
      has_human_agent: false,
      use_tools: watch("use_tools"),
      voiceLanguages: voiceSsts
        .filter((item) => item.locale_code === "en")
        .map((language) => ({
          label: language.name,
          value: language.locale_code,
          id: language.id,
          language_group: language.language_group,
        })),
      attributes: {
        conversation: false,
        contact: false,
      },
      conversation_flow_id: null,
    });

  const onSubmitAssistantPhone = async (data, exit = true) => {
    try {
      setStatus("loading");
      if (
        !data.custom_voice &&
        data.voiceLanguages.some((lang) => !lang.speaker)
      ) {
        toast.error("Please attach a speaker to the language");
        return;
      }

      await fetchController(
        baseUrl +
          (data.id ? `/api/v1/assistant/${data.id}` : "/api/v1/assistant"),
        data.id ? "PUT" : "POST",
        {
          assistant_type: data.assistant_type || "simple",
          llm_model: data.llmModel?.value || "gpt-3.5-turbo-1106",
          name: data.name,
          voice: data.voice,
          system_prompt: data.systemPrompt,
          description: data.description || "string",
          use_tools: watch("use_tools"),
          voice_languages:
            data.voiceLanguages?.map((lang) => ({
              stt: lang.id,
              tts: lang.speaker.value,
            })) || [],
          custom_voice: data.custom_voice,
          attributes: data.attributes || {},
          has_human_agent: data?.has_human_agent || false,
          hide_ds: data?.hide_ds || false,
          show_images: data.showImages || false,
          conversation_flow_id: data?.conversation_flow_id || null,
        }
      );
      toast.success(`Assistant ${data.id ? "updated" : "created"}`);
      !data.id && resetForm();
      if (exit) navigate("/ai-agents/assistants");
    } catch (error) {
      toast.error("Some error occured");
    } finally {
      setStatus("idle");
    }
  };

  const onSubmit = async (data, exit = true) => {
    try {
      setStatus("loading");

      const endpoint = data.id
        ? `/api/v1/assistant/${data.id}`
        : "/api/v1/assistant";
      const urlHit = baseUrl + endpoint;

      if (data.voice) {
        if (data.voiceLanguages.some((lang) => !lang.speaker)) {
          toast.error("Please attach a speaker to the language");
          return;
        }
      }

      const attributes = data.attributes || {};
      if (attributes?.detect_voicemail) {
        attributes["detect_voicemail"] = attributes.detect_voicemail
          ? "hangup"
          : null;
      }
      if (attributes?.conversation_timeout) {
        attributes.conversation_timeout = attributes.conversation_timeout * 60;
      }
      const body = {
        assistant_type: data.assistant_type || "simple",
        llm_model: data.llmModel?.value || "gpt-3.5-turbo-1106",
        name: data.name || "string",
        description: data.description || "string",
        use_tools: watch("use_tools"),
        attributes,
        system_prompt: data.systemPrompt,
        voice: data.voice,
        voice_languages:
          data.voiceLanguages?.map((lang) => ({
            stt: lang.id,
            tts: lang.speaker && lang.speaker.value,
          })) || [],
        custom_voice: data.custom_voice,
        show_images: data.showImages,
        hide_ds: data.hide_ds || false,
        has_human_agent: data.has_human_agent,
        conversation_flow_id: data?.conversation_flow_id || null,
      };
      await fetchController(urlHit, data.id ? "PUT" : "POST", body);
      toast.success(
        data.id ? "Assistant Updated" : "Assistant Added",
        "success"
      );
      !data.id && resetForm();
      if (exit) navigate("/ai-agents/assistants");
    } catch (error) {
      toast.error("Some error occured");
    } finally {
      setStatus("idle");
    }
  };

  const loadOwnVoice = async () => {
    const endpoint = `/api/v1/voice/list`;
    const urlHit = baseUrl + endpoint;
    const getData = await fetchController(urlHit, "GET");

    const modifiedData = getData?.data?.items?.map((val, index) => {
      return {
        value: val.id,
        label: val.name,
      };
    });

    setMyownVoiceOptions(modifiedData);
  };
  useEffect(() => {
    loadOwnVoice();
  }, []);

  const [voiceSsts, setVoiceSsts] = useState([]);
  const [voices, setVoices] = useState([]);
  const languages = voiceSsts.map((language) => ({
    label: language.name,
    value: language.locale_code,
    id: language.id,
    language_group: language.language_group,
    voicestt_provider: language.voicestt_provider,
  }));

  const getAssistantTool = async () => {
    try {
      const response = await fetchController(
        baseUrl + `/api/v1/assistant/${assistantId}/LinkAssistantTool`,
        "GET"
      );
      setLinkAssistantTools(response?.data?.items || []);
      setValue("use_tools", response?.data?.items?.length > 0);
    } catch (e) {
      console.error(e);
    }
  };

  const getVoices = async (queries = {}) => {
    const { searchQuery, provider, language } = queries;
    let queryParams = [];

    if (searchQuery) queryParams.push(`search_term=${searchQuery}`);
    if (provider) queryParams.push(`provider=${provider}`);
    if (language) queryParams.push(`language=${language}`);

    const queryString = queryParams.length ? `&${queryParams.join("&")}` : "";

    const { data: voicesData } = await fetchController(
      baseUrl + `/api/v1/voice/list/voicetts?size=1000${queryString}`
    );
    setVoices(voicesData.items);

    return voicesData;
  };

  useEffect(() => {
    (async () => {
      setStatus("loadingAssitant");

      const response = await fetchController(
        baseUrl + "/api/v1/voice/list/voicestt?size=1000"
      );
      const voicesData = await getVoices();
      setVoiceSsts(response.data.items);
      setMember(state?.credits?.human_agents > 0 ? true : false);
      if (assistantId) {
        try {
          const { data } = await fetchController(
            baseUrl + `/api/v1/assistant/${assistantId}`
          );
          setEditData(data);
          await getAssistantTool();

          setValue("assistant_type", data.assistant_type);
          setValue("custom_voice", data.custom_voice);
          setValue("name", data.name);
          setValue("hide_ds", data.hide_ds || false);
          setValue("has_human_agent", data.has_human_agent || false);

          setValue("description", data.description);
          setValue("systemPrompt", data.system_prompt);

          setValue("voice", data.voice);
          const selectedStts = data.voice_languages.map(
            (voice_lang) => voice_lang.stt
          );

          const selectedVoiceLanguages = response.data.items
            .filter((lang) => selectedStts.includes(lang.id))
            .map((language) => ({
              label: language.name,
              value: language.locale_code,
              id: language.id,
              language_group: language.language_group,
              voicestt_provider: language.voicestt_provider,
            }));

          const voiceLanguages = selectedVoiceLanguages.map(
            (selectedVoiceLang, index) => {
              const speakerId = data.voice_languages[index].tts;
              const voicePerson = voicesData.items.find(
                (voice) => speakerId === voice.id
              );
              return {
                ...selectedVoiceLang,
                speaker: voicePerson && {
                  label: `${voicePerson.name} (${voicePerson.credits}) credits`,
                  value: speakerId,
                  voicetts_provider: voicePerson.voicetts_provider,
                },
              };
            }
          );

          setValue("voiceLanguages", voiceLanguages);
          setValue("showImages", data.show_images);
          setValue("id", data.id);
          setValue("assistant_type", data.assistant_type);
          setValue("attributes", {
            ...data.attributes,
            conversation_timeout: data.attributes?.conversation_timeout
              ? data.attributes?.conversation_timeout / 60
              : null,
          });
          setValue("conversation_flow_id", data?.conversation_flow_id || null);
        } catch (error) {
          resetForm();
        } finally {
          setStatus("idle");
        }
      } else {
        resetForm();

        setValue(
          "voiceLanguages",
          response.data.items
            .filter((item) => item.locale_code === "en")
            .map((language) => ({
              label: language.name,
              value: language.locale_code,
              id: language.id,
              language_group: language.language_group,
              voicestt_provider: language.voicestt_provider,
            }))
        );
      }
      setStatus("idle");
    })();
  }, [assistantId, baseUrl]);

  const loadingAssitant = status === "loadingAssitant";

  const handlePromptSave = () => {
    const text = getValues("systemPrompt");
    const systemPromptText = text.replace(/\s\/$/, "");
    setValue("systemPrompt", systemPromptText);
    return systemPromptText;
  };

  const onSaveAndExit = async () => {
    const submit =
      watch("assistant_type") === "simple"
        ? handleSubmit(onSubmit)
        : handleSubmit(onSubmitAssistantPhone);
    handlePromptSave();
    submit();
  };

  const onSave = () => {
    handleSubmit((data) => {
      const promptText = handlePromptSave();
      data.systemPrompt = promptText;
      if (data.assistant_type === "phone") {
        onSubmitAssistantPhone(data, false);
      } else {
        onSubmit(data, false);
      }
    })();
  };

  const toolTipMsg =
    myDetails && myDetails?.agency_id
      ? `Please contact ${myDetails?.branding?.agency_name || ""} `
      : "Please upgrade to Platinum or above";

  const assistantTabList = {
    Model: [
      {
        title: "LLM Related",
        icon: HiOutlineCpuChip,
        component: (
          <LLMrelated
            editData={editData}
            promptType={promptType}
            setPromptType={setPromptType}
          />
        ),
      },
      {
        title: "Prompt",
        icon: BiMessageSquareDetail,
        component: (
          <Prompt promptType={promptType} setPromptType={setPromptType} />
        ),
      },
    ],
    "Voice (In & Out)": [
      {
        title: " Voice",
        icon: MdOutlineSettingsVoice,
        component: (
          <VoicesField
            myownVoiceOptions={myownVoiceOptions}
            languages={languages}
            voices={voices}
            getVoices={getVoices}
          />
        ),
      },
    ],
    Tools: [
      {
        title: "Tools",
        icon: VscTools,
        component: (
          <ConnectTools
            assistantId={assistantId}
            getAssistantTool={getAssistantTool}
            linkAssistantTools={linkAssistantTools}
          />
        ),
      },
    ],
    "Data Sources": [
      {
        title: "Data Sources",
        icon: TiChartBarOutline,
        component: (
          <DataSourcesField member={member} assistantId={assistantId} />
        ),
      },
    ],
    Advanced: [
      {
        title: "AllowHumanHandover",
        component: (
          <AllowHumanHandover member={member} toolTipMsg={toolTipMsg} />
        ),
      },
      {
        title: "Form",
        icon: IoDocumentTextOutline,
        component: (
          <FormFields assistantId={assistantId} linkAssistantForms={[]} />
        ),
      },
      {
        title: "Conversation",
        icon: BiConversation,
        component: <ConversationFields member={member} />,
      },
      {
        title: "Webhook & intent",
        icon: PiBookOpenTextLight,
        component: (
          <WebhookAndIntentFields assistantId={assistantId} fetch={null} />
        ),
      },
    ],
    Deploy: [
      {
        title: "Deploy",
        icon: GrDeploy,
        component: <NewDeployemnt assistantData={editData} />,
      },
    ],
  };
  const tagSelectHook = useTagSelect({
    entity_id: watch("id"),
    entity_type: "assistant",
  });

  return (
    <>
    <FormProvider {...assistantFormMethod}>
        <form style={{ height: "100%" }}>
          {loadingAssitant ? (
            <Flex justifyContent={"center"} alignItems={"center"} h={"100%"}>
              <Spinner />
            </Flex>
          ) : (
            <VStack h="100%" spacing={2} borderRadius="md">
              <Flex direction={"column"} gap={3} w={"100%"}>
                <Flex gap={2} w={"100%"} alignItems="center" py={2}>
                  <IconButton
                    icon={<IoMdArrowRoundBack />}
                    variant="outline"
                    size="sm"
                    onClick={() => navigate(-1)}
                  />
                  <Heading color={textColor} fontSize="xl">
                    {watch("id") ? "Update Assistant" : "Add an Assistant"}
                  </Heading>
                </Flex>

                <Flex justifyContent={"flex-end"} w={"100%"} gap={2}>
                  <Button
                    type="button"
                    colorScheme={buttonColorScheme}
                    isLoading={loading}
                    onClick={onSaveAndExit}
                  >
                    Save & Exit
                  </Button>
                  {watch("id") ? (
                    <Button
                      type="button"
                      isLoading={loading}
                      colorScheme={buttonColorScheme}
                      onClick={onSave}
                    >
                      Save
                    </Button>
                  ) : null}
                </Flex>

                <BasicDetails id={watch("id")} tagSelectHook={tagSelectHook} />
                <AssistantType voiceSsts={voiceSsts} voices={voices} />
              </Flex>

              <Box overflowY={"auto"} w={"100%"}>
                <Tabs>
                  <TabList>
                    {Object.keys(assistantTabList)
                      .filter(
                        (assistantTab) =>
                          !(
                            watch("assistant_type") === "realtime_openai" &&
                            assistantTab === "Data Sources"
                          ) && !(!assistantId && assistantTab === "Deploy")
                      )
                      .map((key) => {
                        return <Tab key={key}>{key}</Tab>;
                      })}
                  </TabList>

                  <TabPanels>
                    {Object.entries(assistantTabList)
                      .filter(
                        ([key]) =>
                          !(
                            watch("assistant_type") === "realtime_openai" &&
                            key === "Data Sources"
                          )
                      )
                      .map(([key, value]) => (
                        <TabPanel key={key}>
                          {value.map((tabPanel, index) => (
                            <React.Fragment key={index}>
                              {tabPanel.component}
                            </React.Fragment>
                          ))}
                        </TabPanel>
                      ))}
                  </TabPanels>
                </Tabs>
              </Box>
            </VStack>
          )}
        </form>
      </FormProvider>
      {tagSelectHook.tagDrawerDisclosure?.isOpen && (
        <TagModal
          isOpen={tagSelectHook.tagDrawerDisclosure.isOpen}
          onClose={tagSelectHook.tagDrawerDisclosure.onClose}
          tagToEdit={tagSelectHook.tagToEdit}
          setTagToEdit={tagSelectHook.setTagToEdit}
          cb={tagSelectHook.onCreateTag}
        />
      )}
    </>
      
  );
};

export default AddEditAssistant_new;
